export interface UsuarioAbm {
  rowid: string;
  username: string;
  apellidoPaterno: string;
  apellidoMaterno: string;
  clave: string;
  productor: string;
  alta: string;
  activo: boolean;
}

export const PERFILES_USUARIO: string[] = [
  'Usuario Autos',
  'Usuario Interno',
  'Usuario Administrador'
];

export const ADMIN_PROFILES: string[] = ['Usuario Administrador'];
